import ofertaDigital from "@/config/brands/ofertaDigital.js";

describe("ofertaDigital all", () => {
    it("googleAnalyticsId", () => {
        expect(ofertaDigital.googleAnalyticsId).toBe(null);
    });

    it("googleGTMId", () => {
        expect(ofertaDigital.googleGTMId).toBe(null);
    });

    it("modulo", () => {
        expect(ofertaDigital.modulo).toBe("");
    });

    it("cantPasos", () => {
        expect(ofertaDigital.cantPasos).toBe(2);
    });

    it("pasos", () => {
        expect(ofertaDigital.pasos).toStrictEqual({
            paso1: {
              path: "/",
              component: "views/Paso1",
              paso: 1,
              pasoSiguiente: "paso2",
              titulo: "Completá el formulario",
              subtitulo: "Ingresá tus datos, luego solicitá el cambio de banco.",
              subtitulo2:
                "Comenzá a acreditar tu jubilación ANSES en BBVA y te regalamos otra de $160.000"
            },
            gracias: {
              path: "/gracias",
              component: "views/Gracias"
            },
            mensaje: {
              path: "/mensaje/:mje",
              component: "views/Mensaje"
            }
          });
    });
})